import { config } from "../../config/config";
import { HttpServices } from "../../Helper";

export const GetMetaCampaignHistoryLog = async (body) => {
  try {
    const result = await HttpServices.post(
      `${config.server_address}/CrmDfm/PropertyMarketing/GetMetaCampaignHistoryLog`,
      body
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};

export const SyncMetaCampaignHistoryLog = async (body) => {
  try {
    const result = await HttpServices.post(
      `${config.server_address}/CrmDfm/PropertyMarketing/SyncMetaCampaignHistoryLog`,
      body
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};

export const ExportCampaignHistoryLog = async (body) => {
  try {
    const result = await HttpServices.post(
      `${config.server_address}/CrmDfm/PropertyMarketing/ExportCampaignHistoryLog`,
      body,
      { responseType: "blob" }
    );
    return result;
  } catch (error) {
    throw error.response;
  }
};
